import snapShotService from '../../../core/services/Fundamental/SnapShotService';
import {
  getCodeFromQuery,
  getQueryParams,
  getSyncDefaultSearch,
} from '../../helpers/Common';
import reducerRegistry from '../../helpers/ReducerRegistry';
import {
  formatPercent,
  formatValueBillion,
  formatValueTrillion,
} from '../../helpers/Text';
import priceDatService from '../../../core/services/Prices/PriceData/PriceDataService';
import Const from './Const';
import { I18n } from 'react-redux-i18n';
import { cloneDeep } from 'lodash';
import request from '../../helpers/Request';
import chartTickerService from '../../../core/services/Market/Watchlist/ChartTickerService';
import registerCancelTokenAxios from './../../helpers/RegisterCancelTokenAxios';
import { executeRealtimeData } from '../../helpers/Chart';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

export const REDUCER_NAME = 'FA_SNAPSHOT:';
export const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const FETCH_DATA_SNAPSHOT_SUCCESS = `${REDUCER_NAME}FETCH_DATA_SNAPSHOT`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const FETCH_LATEST_PRICE_SUCCESS = `${REDUCER_NAME}FETCH_LATEST_PRICE_SUCCESS`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const FETCH_COMPANY_SCORE = `${REDUCER_NAME}FETCH_COMPANY_SCORE`;
const CHANGE_FILTER = `${REDUCER_NAME}CHANGE_FILTER`;
const FETCH_LIST_CHART = `${REDUCER_NAME}FETCH_LIST_CHART`;
const CHANGE_TIME_RANGE = `${REDUCER_NAME}CHANGE_TIME_RANGE`;
const SUBSCRIBE_REALTIME = `${REDUCER_NAME}SUBSCRIBE_REALTIME`;
const SET_CURRENT_SEARCH = `${REDUCER_NAME}SET_CURRENT_SEARCH`;
const SET_FETCH_CHART_LOADING = `${REDUCER_NAME}SET_FETCH_CHART_LOADING`;

const _format = require('string-format');
_format.extend(String.prototype, {});
const maxLengthData = 5;
const maxQuarterLengthData = 8;
const formatCategory = I18n.t('snapShot.formatCategory');

export const setFetchChartLoading = (componentId, isLoading = true) => {
  return {
    type: SET_FETCH_CHART_LOADING,
    payload: {
      componentId,
      isLoading,
    },
  };
};

export const changeFilter = (timeFilter, componentId) => {
  return {
    type: CHANGE_FILTER,
    payload: {
      componentId,
      timeFilter,
    },
  };
};

export const changeCurrentSearch = (payload, id) => {
  return {
    type: SET_CURRENT_SEARCH,
    payload: {
      componentId: id,
      currentSearch: payload,
    },
  };
};

export const setLoading = (componentId, isLoading = true) => ({
  type: SET_LOADING,
  payload: {
    componentId,
    isLoading,
  },
});

export const formatDataChart = ({ data, isBank, isInsurance }) => {
  data.forEach(dataItems => {
    const dataArrQuarterly = dataItems.quarterly || [];
    dataArrQuarterly.forEach(dataQuarterly => {
      const dataPrevYear = dataArrQuarterly.filter(
        e =>
          e.year === dataQuarterly.year - 1 &&
          e.quarter === dataQuarterly.quarter,
      );
      caculateDataItem(dataQuarterly, dataPrevYear, isBank, isInsurance);
      dataQuarterly.category = _format(
        formatCategory,
        dataQuarterly.quarter,
        dataQuarterly.year.toString().substr(2),
      );
    });

    dataItems.yearly.forEach(dataYearly => {
      dataYearly.category = dataYearly.year;
      const dataPrevYear = dataItems.yearly.filter(
        e => e.year === dataYearly.year - 1,
      );
      caculateDataItem(dataYearly, dataPrevYear, isBank, isInsurance);
    });

    // get nearest 5  quarterly or yearly
    (dataItems.quarterly || []).reverse();
    (dataItems.quarterly || []).splice(
      isBank ? maxLengthData : maxQuarterLengthData,
    );
    (dataItems.quarterly || []).reverse();
    dataItems.yearly.reverse();
    dataItems.yearly.splice(maxLengthData);
    dataItems.yearly.reverse();
  });

  return data;
};

export const fetchLatestPriceSuccess = (
  latestPrice,
  currentSearch,
  componentId,
) => {
  return {
    type: FETCH_LATEST_PRICE_SUCCESS,
    payload: {
      latestPrice,
      currentSearch,
      componentId,
    },
  };
};

export const fetchLatestPrice = (currentSearch, componentId) => dispatch => {
  const params = {
    OrganCode: currentSearch.code,
    Code: currentSearch.code,
  };
  priceDatService.getLatestPrice(params).then(response => {
    const items = response ? response.items : [];
    const latestPrice = items && items.length > 0 ? items[0].priceInfo : {};

    dispatch(fetchLatestPriceSuccess(latestPrice, currentSearch, componentId));
  });
};

export const fetchDataSnapshotSearch = (currentSearch, componentId) => {
  return dispatch => {
    dispatch(setFetchChartLoading(componentId));
    const handleSuccess = response => {
      dispatch(setFetchChartLoading(componentId, false));
      const listDataSnapShot = cloneDeep(response.items) || [];
      dispatch({
        type: FETCH_DATA_SNAPSHOT_SUCCESS,
        payload: {
          listDataSnapShot,
          componentId,
          currentSearch,
        },
      });
    };
    if (currentSearch.isBanking) {
      snapShotService
        .getDataSnapshot({ OrganCode: currentSearch.code })
        .then(handleSuccess);
      return;
    }
    snapShotService
      .getDataSnapshotNonBank({ OrganCode: currentSearch.code })
      .then(handleSuccess);
  };
};

export const caculateDataItem = (arrData, arrDataPrev, isBank, isInsurance) => {
  if (isInsurance) {
    arrData.isa1 = arrData.isi103;
  }
  if (arrDataPrev.length > 0) {
    arrData.netProfitGrowth = caculateGrowth(
      arrData,
      arrDataPrev[0],
      1,
      'isa22',
    );
    arrData.totalAssetGrowth = caculateGrowth(
      arrData,
      arrDataPrev[0],
      1,
      'bsa53',
    );
    arrData.loansGrowth = getGrowth(arrData, arrDataPrev[0], 'bsb104');

    arrData.depositGrowth = getGrowth(arrData, arrDataPrev[0], 'bsb113');
  } else {
    arrData.netProfitGrowth = formatPercent(0);
    arrData.totalAssetGrowth = formatPercent(0);
    arrData.loansGrowth = formatPercent(0);
    arrData.depositGrowth = formatPercent(0);
  }
  arrData.loans = formatValueTrillion(arrData.bsb104);
  arrData.deposit = formatValueTrillion(arrData.bsb113);
  // arrData.cashCycle = formatTextFloat(
  //   arrData.rqq18 + arrData.rqq16 - arrData.rqq20,
  // );
  arrData.cashCycle = arrData.rqq18 + arrData.rqq16 - arrData.rqq20;

  let lstKeyFormatBillion = [
    'isa1',
    'cfa18',
    'isa22',
    'cfa26',
    'cfa34',
    'bsa1',
    'bsa23',
    'bsa54',
    'bsa78',
    'netSales',
    'cfa10',
    'cfa11',
    'cfa12',
    'bsa9',
    'bsa16',
    'bsa57',
  ];
  let lstKeyFormatThounsandBillion = ['isb27', 'bsa53', 'nob44'];
  if (isBank) {
    lstKeyFormatBillion = [
      'isa1',
      'cfa18',
      'cfa26',
      'cfa34',
      'bsa1',
      'bsa23',
      'bsa54',
      'bsa78',
    ];
    lstKeyFormatThounsandBillion = ['isb27', 'isa22', 'bsa53', 'nob44'];
  }
  const lstKeyFormatPercent = [
    'rtq25',
    'bsa80',
    'rtq44',
    'rtq137',
    'rtq29',
    'rqq12',
    'rqq23',
    'rqq25',
    'rqq27',
    'rqq29',
    'rqq52',
    'rqq76',
  ];
  lstKeyFormatBillion.forEach(item => {
    arrData[item] = arrData[item]
      ? formatValueBillion(arrData[item])
      : arrData[item];
  });
  lstKeyFormatThounsandBillion.forEach(item => {
    arrData[item] = arrData[item]
      ? formatValueTrillion(arrData[item])
      : arrData[item];
  });

  lstKeyFormatPercent.forEach(item => {
    arrData[item] = arrData[item]
      ? formatPercent(arrData[item])
      : arrData[item];
  });
};

export const getGrowth = (item, itemPrev, keyName) => {
  return formatPercent(item[keyName] / itemPrev[keyName] - 1);
};

export const caculateGrowth = (item, itemPrev, type, keyName, keyName2) => {
  if (type === 1) {
    return formatPercent(
      formatValueTrillion(item[keyName]) / itemPrev[keyName] - 1,
    );
  } else {
    return formatPercent(
      (item[keyName] + item[keyName2]) /
        (itemPrev[keyName] + itemPrev[keyName2]) -
        1,
    );
  }
};

export const fetchCompanyScore = (organCode, componentId) => {
  return dispatch => {
    snapShotService.getCompanyScore({ OrganCode: organCode }).then(res => {
      const { items = [] } = res ? res : [];
      const data = items && items[0] ? items[0] : {};

      dispatch({
        type: FETCH_COMPANY_SCORE,
        payload: {
          componentId,
          data,
        },
      });
    });
  };
};

export const fetchListChart = (currentSearch, timeRange, componentId) => {
  return dispatch => {
    registerCancelTokenAxios.delete(REDUCER_NAME + '.' + componentId);
    dispatch(setLoading(componentId));
    request.fetchApi(
      params => {
        const source = registerCancelTokenAxios.register(
          REDUCER_NAME + '.' + componentId,
        );

        return chartTickerService.getTickerSeries(
          {
            OrganCode: currentSearch.code,
            TimeRange: timeRange,
            ...params,
          },
          source,
        );
      },
      data => {
        dispatch({
          type: FETCH_LIST_CHART,
          payload: {
            data,
            componentId,
            timeRange,
          },
        });
      },
      () => {
        dispatch(setLoading(componentId, false));
      },
      () => {
        dispatch(setLoading(componentId, false));
      },
    );
  };
};

export const changeTimeRange = (timeRange, componentId) => {
  return {
    type: CHANGE_TIME_RANGE,
    payload: {
      timeRange,
      componentId,
    },
  };
};

export const subscribeRealtimePrice = (data, componentId) => {
  return (dispatch, getState) => {
    const currentSearch = getState()[REDUCER_NAME].listMultiComponent[
      componentId
    ].currentSearch;
    const price = data.find(item => item.organCode === currentSearch.code);

    if (price) {
      dispatch({
        type: SUBSCRIBE_REALTIME,
        payload: {
          componentId,
          data: price,
        },
      });
      dispatch(fetchLatestPriceSuccess(price, currentSearch, componentId));
    }
  };
};

const initialState = {
  listMultiComponent: {},
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case INIT_COMPONENT: {
      const { id: componentId } = action.payload;
      const mapTimeFilter = {
        yearly: 2,
        quarterly: 1,
      };
      return {
        ...state,
        ...initialState,
        listMultiComponent: {
          ...(state.listMultiComponent || {}),
          [componentId]: {
            data: [],
            currentSearch: {
              code: Const.DEFAULT_CODE,
              displayCode: Const.DEFAULT_CODE,
              isBanking: false,
            },
            latestPrice: {},
            score: {},
            timeFilter: mapTimeFilter[getQueryParams('period')],
            dataChartIndex: [],
            timeRange: Const.timeRange['1Y'],
          },
        },
      };
    }

    case UNMOUNT_COMPONENT:
      const delId = action.payload.id;
      const cloneListComponent = { ...state.listMultiComponent };
      const { [delId]: _, ...withoutDeleteKey } = cloneListComponent;
      if (Object.keys(withoutDeleteKey).length === 0) {
        return {};
      }
      return {
        ...state,
        listMultiComponent: withoutDeleteKey,
      };

    case SUBSCRIBE_REALTIME: {
      const { data, componentId } = action.payload;

      return data &&
        state.listMultiComponent[componentId].timeRange ===
          Const.timeRange['1D']
        ? {
            ...state,
            listMultiComponent: {
              ...state.listMultiComponent,
              [componentId]: {
                ...state.listMultiComponent[componentId],
                dataChartIndex: executeRealtimeData(data, [
                  ...state.listMultiComponent[componentId].dataChartIndex,
                ]),
              },
            },
          }
        : state;
    }

    case FETCH_DATA_SNAPSHOT_SUCCESS: {
      const { listDataSnapShot, componentId, currentSearch } = action.payload;
      const dataChart = formatDataChart({
        data: listDataSnapShot,
        isBank: currentSearch.isBanking,
        isInsurance: currentSearch.isInsurance,
      });

      currentState.add(
        ConstCommon.listComponent.FASnapshot,
        'currentSearch',
        {
          code: currentSearch.code,
          displayCode: currentSearch.displayCode,
          isBanking: currentSearch.isBanking,
          isInsurance: currentSearch.isInsurance,
        },
        componentId,
      );

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            data: dataChart,
          },
        },
      };
    }

    case SET_CURRENT_SEARCH:
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [action.payload.componentId]: {
            ...state.listMultiComponent[action.payload.componentId],
            currentSearch: action.payload.currentSearch,
          },
        },
      };

    case SET_LOADING:
      const { componentId, isLoading } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            isLoading,
          },
        },
      };
    case SET_FETCH_CHART_LOADING:
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [action.payload.componentId]: {
            ...state.listMultiComponent[action.payload.componentId],
            isChartLoading: action.payload.isLoading,
          },
        },
      };

    case FETCH_LATEST_PRICE_SUCCESS: {
      const { latestPrice, componentId } = action.payload;

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            latestPrice,
          },
        },
      };
    }

    case CHANGE_SIZE_COMPONENT: {
      const { id: componentId } = action.payload;

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            component: action.payload,
          },
        },
      };
    }

    case CHANGE_FILTER: {
      const { timeFilter, componentId } = action.payload;

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            timeFilter,
          },
        },
      };
    }

    case FETCH_COMPANY_SCORE: {
      const { componentId, data } = action.payload;

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            score: data,
          },
        },
      };
    }

    case FETCH_LIST_CHART: {
      const { componentId, data, timeRange } = action.payload;
      if (timeRange !== state.listMultiComponent[componentId].timeRange) {
        return state;
      }
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            dataChartIndex: data,
            timeRange,
          },
        },
      };
    }

    case CHANGE_TIME_RANGE:
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [action.payload.componentId]: {
            ...state.listMultiComponent[action.payload.componentId],
            timeRange: action.payload.timeRange,
          },
        },
      };

    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
